import { showErrorToast } from "@/utils/toast"
import { slugify } from "@/utils/strings"
import { getI18n } from "@/plugins/0.i18n"

const i18n = getI18n().global
const basicAuth = import.meta.env.VITE_BACKEND_TEST_BASIC_AUTH

/**
 * @param {URLSearchParams} params same query the visits history list is showing, so the
 *                                 spreadsheet always matches what is on screen
 */
const fetchVisitHistoryXlsBlob = async (params) => {
  const accessToken = useCookie('accessToken').value
  if (!accessToken) {
    console.error('accessToken not set')
    showErrorToast(i18n.t('access_denied_please_reload_this_page'))

    return null
  }

  try {
    const response = await fetch(`${import.meta.env.VITE_BACKEND_SERVER_URL}/clients/exportVisits?${params}`, {
      method: 'GET',
      headers: {
        'Basic-Authorization': `Basic ${basicAuth}`,
        'Authorization': `Bearer ${accessToken}`,
      },
    })

    if (!response.ok) {
      console.error('Error fetching visit history XLS:', response.statusText)
      showErrorToast(i18n.t('access_denied_please_reload_this_page'))

      return null
    }

    return await response.blob()
  } catch (error) {
    console.error('Error fetching visit history XLS:', error)
    showErrorToast(i18n.t('access_denied_please_reload_this_page'))

    return null
  }
}

/**
 * @param {URLSearchParams} params      built by customerStore.buildVisitsHistoryParams()
 * @param {string} [customerName]
 * @param {string} [customerSurname]
 */
export const downloadVisitHistoryXls = async (params, customerName, customerSurname) => {
  const blob = await fetchVisitHistoryXlsBlob(params)
  if (!blob) return

  const clientId = params.get('id')

  let clientLabel = ""
  if (customerName) clientLabel += slugify(customerName)
  if (customerName && customerSurname ) clientLabel += "_"
  if (customerSurname) clientLabel += slugify(customerSurname)
  if (clientLabel.length <= 1) clientLabel = clientId

  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.setAttribute('download', `wizyty_klienta-${clientLabel}-${Date.now()}.xlsx`)
  document.body.appendChild(link)
  link.click()

  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
